module.exports = __webpack_public_path__ + "4e15f518bdd5af38307cb7535fdd6e11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_32.jpg
// module id = 1708
// module chunks = 5